import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
  class: "mb-6"
};
const _hoisted_2 = {
  class: "mb-6"
};
const _hoisted_3 = {
  class: "flex w-full py-2 tw"
};
const _hoisted_4 = {
  class: "w-9/12"
};
const _hoisted_5 = {
  class: "w-1/12 pb-2"
};
const _hoisted_6 = {
  class: "flex w-full pt-2"
};
const _hoisted_7 = {
  class: "w-6/12 matter-name-list"
};
const _hoisted_8 = {
  key: 0,
  class: "text-caption text-warning mt-1",
  "data-cy": "matter-name-qbo-warning"
};
const _hoisted_9 = {
  class: "w-4/12 pl-1"
};
const _hoisted_10 = {
  class: "flex w-full"
};
const _hoisted_11 = {
  class: "w-2/12"
};
const _hoisted_12 = {
  class: "flex items-center pt-2"
};
const _hoisted_13 = {
  class: "w-9/12"
};
const _hoisted_14 = {
  key: 0,
  class: "flex w-full py-2"
};
const _hoisted_15 = {
  class: "w-9/12"
};
const _hoisted_16 = {
  class: "flex w-full py-2"
};
const _hoisted_17 = {
  class: "w-2/12"
};
const _hoisted_18 = {
  class: "flex items-center pt-2"
};
const _hoisted_19 = {
  class: "w-6/12",
  id: "billing-type"
};
const _hoisted_20 = {
  key: 1,
  class: "flex w-full py-2"
};
const _hoisted_21 = {
  class: "w-6/12"
};
const _hoisted_22 = {
  key: 2,
  class: "flex w-full py-2"
};
const _hoisted_23 = {
  class: "w-6/12",
  id: "rate-group"
};
const _hoisted_24 = {
  key: 3,
  class: "flex w-full py-2"
};
const _hoisted_25 = {
  class: "w-6/12"
};
const _hoisted_26 = {
  class: "pl-2 pt-3"
};
const _hoisted_27 = {
  key: 4,
  class: "flex w-full py-2"
};
const _hoisted_28 = {
  class: "w-2/12"
};
const _hoisted_29 = {
  class: "pt-2"
};
const _hoisted_30 = {
  key: 0,
  class: "font-weight-bold mr-1"
};
const _hoisted_31 = {
  class: "w-6/12"
};
const _hoisted_32 = {
  key: 5,
  class: "flex w-full py-2"
};
const _hoisted_33 = {
  class: "w-6/12"
};
const _hoisted_34 = {
  key: 6,
  class: "d-flex align-center justify-center"
};
const _hoisted_35 = {
  key: 7
};
const _hoisted_36 = {
  class: "flex w-full py-2",
  "data-cy": "netdocs-status-message"
};
const _hoisted_37 = {
  class: "text-base text-center py-2 px-3 rounded bg-green-100"
};
const _hoisted_38 = {
  key: 0
};
const _hoisted_39 = {
  key: 0,
  "data-cy": "netdocs-warning"
};
const _hoisted_40 = {
  key: 0
};
const _hoisted_41 = {
  key: 0,
  class: "bg-yellow-200 text-center text-base px-2 py-2 rounded-md my-2"
};
const _hoisted_42 = {
  key: 1,
  class: "bg-yellow-200 text-center text-base px-2 py-2 rounded-md my-2"
};
const _hoisted_43 = {
  key: 1,
  class: "py-2"
};
const _hoisted_44 = {
  key: 0,
  class: "bg-[rgba(var(--v-theme-error),0.08)] text-center text-base px-2 py-2 rounded-md"
};
const _hoisted_45 = {
  class: "flex w-full justify-end"
};
const _hoisted_46 = {
  key: 0,
  class: "w-6/12 px-4"
};
import { reactive, computed, onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import RouteService from '@/services/RouteService';
import useClientMatterStore from '@/services/useClientMatterStore';
import useClientMatterOptionsStore from '@/services/useClientMatterOptionsStore';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import ClientMatterSearch from '@/components/ClientMatterSearch.vue';
import ClientIdInput from '@/components/ClientIdInput.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlPracticeAreaSelect from '@/components/LlPracticeAreaSelect.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import LlSupport from '@/components/LlSupport.vue';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
import { useRateGroupStore } from '@/services/useRateGroupStore.js';
import { useCustomFieldStore } from '@/services/customFieldStore.js';
import { useNetDocsStore } from '@/services/useNetDocsStore.js';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import { getAssignableUsers } from '@/services/utils.js';
import billingTypes from '@/constants/billingTypes.js';
const contingencyFeeErrorMessage = 'Enter a number between 0 and 100 with up to 8 decimals';
export default {
  __name: 'CreateMatter',
  props: {
    stateParams: Object,
    state: Object,
    methodOverride: {
      type: String,
      default: ''
    },
    clientId: String
  },
  emits: ['close', 'matterCreated'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const meStore = useMeStore();
    const clientMatterStore = useClientMatterStore();
    const cmOptionsStore = useClientMatterOptionsStore();
    const routeService = new RouteService(props);
    const {
      handleError
    } = useSnackbarHandler();
    const {
      listAccounts
    } = useAccountsStore();
    const {
      listRateGroup
    } = useRateGroupStore();
    const {
      listMatterTags
    } = useCustomFieldStore();
    const netDocsStore = useNetDocsStore();
    const {
      accountsList
    } = storeToRefs(useAccountsStore());
    const {
      rateGroupList
    } = storeToRefs(useRateGroupStore());
    const {
      matterTags
    } = storeToRefs(useCustomFieldStore());
    const {
      connected: netDocsConnected,
      isDisconnectedUnintentionally,
      loading: netDocsLoading
    } = storeToRefs(netDocsStore);
    const {
      me,
      features
    } = storeToRefs(meStore);
    const snackbar = ref(null);
    const dialogOpen = ref(true);
    const modalRef = ref(null);
    const matterExistsDialog = ref(null);
    const matterIdExistsDialog = ref(null);
    const emit = __emit;
    const matterFormState = reactive({
      matter: {
        opened: new Date(),
        billing: {
          type: ''
        },
        copy: false,
        client: null,
        name: '',
        primary: null,
        originating: null,
        matterTag: null,
        rateGroup: {},
        method: ''
      },
      reference: '',
      nextReference: '',
      billingType: 'hours',
      contingencyFeePercentage: 33.33333333,
      users: [],
      rateGroups: [],
      matterCount: 0,
      matterCopyInfo: {}
    });
    const uiState = reactive({
      loading: true,
      loadingReference: false,
      copyLoading: false,
      clientsLoading: false
    });
    const suggestionState = reactive({
      matterSuggestions: [],
      referenceSuggestions: []
    });
    const cmQueryFilter = computed(() => {
      return {
        originating: false,
        involved: false,
        reviewer: false,
        primary: false,
        status: '',
        archived: false,
        showOrphans: true
      };
    });
    const showCopyBilling = computed(() => {
      return matterFormState.matter.client?.id && matterFormState.matterCount > 0;
    });
    const contingencyFeeRules = [v => {
      if (v == null || v === '' || v === 0) return true;
      if (v < 0 || v > 100) return contingencyFeeErrorMessage;
      if (v > 0 && v < 0.00000001) return contingencyFeeErrorMessage;
      const parts = String(v).split('.');
      if (parts[1] && parts[1].length > 8) return contingencyFeeErrorMessage;
      return true;
    }];
    const isContingencyFeeInvalid = computed(() => {
      if (matterFormState.billingType !== 'contingency') return false;
      const pct = matterFormState.contingencyFeePercentage;
      if (pct == null || pct === '' || pct === 0) return false;
      if (pct < 0.00000001 || pct > 100) return true;
      const parts = String(pct).split('.');
      return parts[1] && parts[1].length > 8;
    });
    const requireOriginating = computed(() => !!me.value?.company?.settings?.requireOriginating);
    const originatingRules = computed(() => requireOriginating.value ? [v => !!v || 'User is required'] : []);

    // Accountants and timekeepers are excluded from the assignable roster, so they
    // can't hold Responsible. Returning the roster entry rather than `me` also keeps
    // the select's model identical to one of its own items.
    function defaultPrimary() {
      return matterFormState.users.find(u => u.id === me.value?.id) ?? null;
    }
    function restoreUserDefaults() {
      matterFormState.matter.primary = defaultPrimary();
      matterFormState.matter.originating = null;
    }
    const missingRequiredFields = computed(() => {
      const matterTerm = me.value?.terms?.Matter || 'Matter';
      const missing = [];
      if (!matterFormState.matter.client) missing.push('Client');
      if (!matterFormState.matter.name) missing.push(`${matterTerm} name`);
      if (!matterFormState.matter.primary?.id) missing.push('Responsible');
      if (requireOriginating.value && !matterFormState.matter.originating?.id) {
        missing.push(`Originating ${me.value?.terms?.lead || 'attorney'}`);
      }
      return missing;
    });
    const saveDisabled = computed(() => missingRequiredFields.value.length > 0 || uiState.loading || isContingencyFeeInvalid.value);
    onMounted(async () => {
      modalRef.value.focus();
      await Promise.all([meStore.getMe(), listAccounts()]);
      await activate();
    });
    async function activate() {
      uiState.loading = true;
      try {
        const clientId = props.stateParams?.clientId || props.clientId;
        matterFormState.users = getAssignableUsers(accountsList.value);

        // Load rate groups
        await getMatterTags();
        matterFormState.matter.primary = defaultPrimary();
        if (clientId) {
          matterFormState.matter.client = {
            id: clientId
          };
          try {
            const requestedClientId = clientId;
            const client = await clientMatterStore.getClientById(requestedClientId);
            const activeClientId = props.stateParams?.clientId || props.clientId;

            // Ignore stale response if selected client changed while request was in flight.
            if (String(activeClientId) === String(requestedClientId)) {
              matterFormState.matter.client = client;
              await clientSelected();
            }
          } catch (error) {
            handleError('Could not load selected client');
          }
        }
        getRateGroup();
        // Check NetDocs status if feature is enabled
        if (features?.value.netdocs) {
          await netDocsStore.checkStatus();
        }
      } catch (error) {
        handleError(error);
      } finally {
        uiState.loading = false;
      }
    }
    async function getRateGroup() {
      await listRateGroup();
      matterFormState.rateGroups = rateGroupList.value.map(group => ({
        id: group.rateGroupId,
        name: group.name,
        default: group.default
      }));
      matterFormState.matter.rateGroup = {};
      matterFormState.matter.rateGroup.rateGroupId = matterFormState.rateGroups.find(rateGroup => rateGroup.default)?.id;
    }
    async function getMatterTags() {
      if (!me.value?.company?.usesMatterTags) return;
      await listMatterTags();
      const tags = matterTags.value.mattertags || [];
      matterFormState.matter.matterTag = tags.find(t => t.default);
    }
    async function clientSelected() {
      if (!matterFormState.matter.client) {
        matterFormState.reference = '';
        return;
      }
      try {
        matterFormState.loadingMatters = true;
        const [matters, matterCount, matterCopyInfo] = await Promise.all([searchMatters('', 'name'), cmOptionsStore.getMatterCount({
          clientId: matterFormState.matter.client.id
        }), cmOptionsStore.getCopyMatter({
          clientId: matterFormState.matter.client.id
        })]);
        suggestionState.matterSuggestions = matters;
        suggestionState.referenceSuggestions = matters.filter(c => c.reference && c.reference.trim());
        matterFormState.matterCount = matterCount;
        matterFormState.matterCopyInfo = matterCopyInfo;
      } catch (error) {
        handleError(error);
      } finally {
        matterFormState.loadingMatters = false;
      }

      // The checkbox means "copy from this client's most recent matter", so a box
      // the user ticked re-copies against the new client rather than keeping the
      // previous client's attorneys. An untouched one is left alone - switching
      // client must never reach in and change who is on the matter.
      if (matterFormState.matter.copy) {
        if (!matterFormState.matterCount) {
          matterFormState.matter.copy = false;
        }
        toggleCopy();
      }
      setMatterID();
    }
    async function searchMatters(name = '', prop = 'name') {
      if (!matterFormState.matter.client) {
        return [];
      }
      const lowerName = name.toLowerCase();
      const matterQuery = {
        ...cmQueryFilter.value,
        clientId: matterFormState.matter.client.id
      };
      try {
        const result = await cmOptionsStore.listMatterOptions(matterQuery);
        const dictionary = {};
        return result.reduce((acc, m) => {
          const val = m[prop]?.toLowerCase();
          if (val && (name === '' || val.indexOf(lowerName) !== -1) && !dictionary[val]) {
            dictionary[val] = true;
            acc.push(m);
          }
          return acc;
        }, []);
      } catch (error) {
        handleError(error);
        return [];
      }
    }
    function toggleCopy() {
      if (matterFormState.matter.copy) {
        // Copy information from previous matter
        // ?? null, not undefined: a copied attorney who has since left the roster
        // (or changed to a role that can't hold the seat) has to read as empty so
        // the required-field guard catches it instead of posting a blank.
        matterFormState.matter.originating = matterFormState.users.find(x => x.id === matterFormState.matterCopyInfo.originatorId) ?? null;
        matterFormState.matter.primary = matterFormState.users.find(x => x.id === matterFormState.matterCopyInfo.primaryId) ?? null;
        matterFormState.matter.rateGroup.rateGroupId = matterFormState.rateGroups.find(rateGroup => rateGroup.id === matterFormState.matterCopyInfo.rateGroupId)?.id;
        matterFormState.billingType = billingTypes.find(x => x.id === matterFormState.matterCopyInfo.billingType)?.id;
        matterFormState.contingencyFeePercentage = matterFormState.matterCopyInfo.contingencyFeePercentage ?? 33.33333333;
      } else {
        restoreUserDefaults();
        matterFormState.matter.rateGroup.rateGroupId = matterFormState.rateGroups.find(rateGroup => rateGroup.default)?.id;
        matterFormState.contingencyFeePercentage = 33.33333333;
      }
    }
    async function setMatterID() {
      if (!matterFormState.matter.client?.id) return;
      uiState.loadingReference = true;
      try {
        const result = await meStore.getMyCompanyReferences(matterFormState.matter.client.id);
        matterFormState.nextReference = result.nextMatterReference;
        matterFormState.reference = matterFormState.nextReference;
      } finally {
        uiState.loadingReference = false;
      }
    }
    function rateGroupChanged() {
      matterFormState.matter.copy = false;
    }
    async function matterNameSelected(selectedMatter) {
      if (!selectedMatter.isCustom && !matterFormState.reference) {
        const matterName = selectedMatter.name || selectedMatter;
        matterFormState.matter.name = matterName;
        const res = await matterExistsDialog.value.open();
        if (res) navigateAfterMatterCreation(selectedMatter);
      }
    }
    async function matterReferenceSelected(selectedMatter) {
      if (!selectedMatter.isCustom) {
        const reference = selectedMatter.reference || selectedMatter;
        matterFormState.reference = reference;
        const res = await matterIdExistsDialog.value.open();
        if (res) navigateAfterMatterCreation(selectedMatter);
      }
    }
    function openClientCreate() {
      dialogOpen.value = false;
      routeService.go('clients.client2', {
        fromVueMatterCreate: true
      });
    }
    async function save(redirectToNewCharge = false) {
      // Every required field is checked here, before the payload is assembled, so
      // an incomplete form never reaches the server. Letting one through means the
      // backend's own default-assignment fallback decides who is Responsible.
      if (missingRequiredFields.value.length) {
        handleError(`These fields are required: ${missingRequiredFields.value.join(', ')}`);
        return;
      }
      matterFormState.matter.billing.type = matterFormState.billingType;

      // Set contingency fee percentage (null if cleared or not contingency billing)
      if (matterFormState.billingType === 'contingency') {
        matterFormState.matter.contingencyFeePercentage = matterFormState.contingencyFeePercentage || null;
      } else {
        matterFormState.matter.contingencyFeePercentage = null;
      }
      if (matterFormState.matter.opened === undefined) {
        matterFormState.matter.opened = new Date();
      }

      // Set up users array
      if (matterFormState.matter.primary) {
        matterFormState.matter.users = [];
        if (matterFormState.matter.primary.id !== me.value.id) {
          matterFormState.matter.users.push({
            id: matterFormState.matter.primary.id,
            primary: true
          });
        }
        const mePrimary = matterFormState.matter.primary.id === me.value.id;
        matterFormState.matter.users.push({
          id: me.value.id,
          primary: mePrimary
        });
      }
      if (matterFormState.matter.originating?.id) {
        matterFormState.matter.users = matterFormState.matter.users || [];
        let user = matterFormState.matter.users.find(u => u.id === matterFormState.matter.originating.id);
        if (!user) {
          user = {
            id: matterFormState.matter.originating.id
          };
          matterFormState.matter.users.push(user);
        }
        user.originating = true;
      }

      // Set reference
      matterFormState.matter.reference = matterFormState.reference === matterFormState.nextReference ? null : matterFormState.reference;
      uiState.loading = true;
      const methodSource = matterFormState.matter.source || props.stateParams?.methodOverride || 'matter page';
      try {
        matterFormState.matter.method = methodSource;
        const matter = await clientMatterStore.createMatter({
          create: matterFormState.matter
        });
        if (matterFormState.billingType === 'fixed') {
          // Handle fixed fee creation if needed
          navigateAfterMatterCreation(matter, redirectToNewCharge);
        } else {
          navigateAfterMatterCreation(matter, redirectToNewCharge);
        }
      } catch (error) {
        uiState.loading = false;
        handleError(error);
      }
    }
    function navigateAfterMatterCreation(created, redirectToNewCharge) {
      if (!created) return;
      const currentStateName = props.state?.current?.name || '';
      const rawRoot = currentStateName.split('.')[0];
      // The bare `matters` root (sc-46278) has no client/matter detail
      // hierarchy of its own - reuse matters-next's, the same one the Matters
      // list's own "View Matter" kebab action already navigates to.
      const root = rawRoot === 'matters' ? 'matters-next' : rawRoot;
      dialogOpen.value = false;
      if (currentStateName.includes('time')) {
        emit('matterCreated', created);
        return;
      }
      if (redirectToNewCharge) {
        return routeService.go(`${root}.client.matter.fixed.charge`, {
          id: created.client ? created.client.id : created.clientId,
          matterId: created.id
        });
      }
      return routeService.go(`${root}.client.matter.info`, {
        id: created.client ? created.client.id : created.clientId,
        matterId: created.id
      });
    }
    function cancel() {
      dialogOpen.value = false;
      const currentStateName = props.state?.current?.name || '';
      if (currentStateName.includes('time')) {
        emit('close');
        return;
      }
      routeService.go('^');
    }
    function openDialog(typedValue = '', method = '') {
      dialogOpen.value = true;
      matterFormState.matter.method = method;
      if (typedValue && typedValue.trim()) {
        matterFormState.matter.name = typedValue.trim();
      }
      modalRef.value?.focus();
    }
    __expose({
      openDialog
    });
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createElementBlock("div", {
        onKeydown: _withKeys(cancel, ["esc"]),
        ref_key: "modalRef",
        ref: modalRef,
        tabindex: "0"
      }, [_createVNode(_component_v_dialog, {
        modelValue: dialogOpen.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => dialogOpen.value = $event),
        "max-width": "650px",
        "content-class": "client-edit-dialog"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, null, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, {
            class: "text-h5 px-6"
          }, {
            default: _withCtx(() => [_createTextVNode(" Create " + _toDisplayString(_unref(me)?.terms?.Matter), 1)]),
            _: 1
          }), uiState.loading ? (_openBlock(), _createBlock(_component_v_card_text, {
            key: 0,
            class: "pa-4"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_skeleton_loader, {
              type: "article, actions",
              class: "mb-6"
            }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_v_skeleton_loader, {
              type: "paragraph",
              class: "mb-2"
            }), _createVNode(_component_v_row, {
              dense: ""
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, n => {
                return _createVNode(_component_v_col, {
                  cols: "6",
                  key: n
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_skeleton_loader, {
                    type: "text",
                    class: "mb-2"
                  })]),
                  _: 1
                });
              }), 64))]),
              _: 1
            })]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_v_skeleton_loader, {
              type: "heading",
              class: "mb-2"
            })])]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_v_card_text, {
            key: 1,
            class: "pt-2 px-6"
          }, {
            default: _withCtx(() => [_createVNode(SnackbarComponent, {
              ref_key: "snackbar",
              ref: snackbar
            }, null, 512), _createElementVNode("div", _hoisted_3, [_cache[17] || (_cache[17] = _createElementVNode("div", {
              class: "w-2/12"
            }, [_createElementVNode("label", {
              class: "pt-2"
            }, "Client")], -1)), _createElementVNode("div", _hoisted_4, [_createVNode(ClientMatterSearch, {
              emitOnAnyChange: true,
              cm: matterFormState.matter,
              "query-filter": cmQueryFilter.value,
              "client-only": true,
              "hide-client-label": true,
              onMatterChange: clientSelected,
              "data-cy": "client-matter-search"
            }, null, 8, ["cm", "query-filter"])]), _createElementVNode("div", _hoisted_5, [_createVNode(LlSecondaryButton, {
              icon: "fa-plus",
              size: "small",
              onClick: openClientCreate,
              disabled: uiState.loading,
              "data-cy": "add-client-button"
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createElementVNode("i", {
                class: "fa fa-plus"
              }, null, -1)]))]),
              _: 1
            }, 8, ["disabled"])])]), _createElementVNode("div", _hoisted_6, [_cache[20] || (_cache[20] = _createElementVNode("div", {
              class: "w-2/12"
            }, [_createElementVNode("label", {
              class: "pt-2"
            }, "Name")], -1)), _createElementVNode("div", _hoisted_7, [_createVNode(ClientIdInput, {
              id: "matterName",
              modelValue: matterFormState.matter.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => matterFormState.matter.name = $event),
              items: suggestionState.matterSuggestions,
              "item-title": "name",
              "item-value": "name",
              placeholder: `${_unref(me)?.terms?.Matter} name`,
              disabled: !matterFormState.matter.client || uiState.loading || matterFormState.loadingMatters,
              rules: [v => !!v || 'This field is required.'],
              onItemSelected: matterNameSelected,
              minWidth: "440",
              maxWidth: "500",
              "data-cy": "matter-name-input"
            }, null, 8, ["modelValue", "items", "placeholder", "disabled", "rules"]), matterFormState.matter.name?.length > 100 ? (_openBlock(), _createElementBlock("div", _hoisted_8, " QuickBooks Online limits trust account names to 100 characters. If you create a trust account for this customer, it will be truncated. ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, [_cache[19] || (_cache[19] = _createTextVNode(" Id ", -1)), _createVNode(LlTooltip, {
              icon: "help",
              class: "mx-1"
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode(" A reference number that you can use to track the matter (optional) ", -1)]))]),
              _: 1
            })])]), _createElementVNode("div", _hoisted_13, [_createVNode(ClientIdInput, {
              modelValue: matterFormState.reference,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => matterFormState.reference = $event),
              items: suggestionState.referenceSuggestions,
              "item-title": "reference",
              "item-value": "reference",
              disabled: uiState.loadingReference,
              placeholder: uiState.loadingReference ? 'loading...' : '- Optional -',
              onItemSelected: matterReferenceSelected,
              "hide-details": true,
              minWidth: "190",
              maxWidth: "300",
              "data-cy": "matter-reference-input"
            }, null, 8, ["modelValue", "items", "disabled", "placeholder"])])])])]), showCopyBilling.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_cache[21] || (_cache[21] = _createElementVNode("div", {
              class: "w-2/12"
            }, null, -1)), _createElementVNode("div", _hoisted_15, [_createVNode(LlCheckbox, {
              id: "billinginfo-checkbox",
              modelValue: matterFormState.matter.copy,
              "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => matterFormState.matter.copy = $event), toggleCopy],
              label: `Copy billing and rate info from recent ${_unref(me)?.terms?.matter}`,
              info: "This will copy the access and billing information from the most\n                recently updated matter under this client.",
              "data-cy": "copy-billing-checkbox"
            }, null, 8, ["modelValue", "label"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("label", _hoisted_18, [_cache[22] || (_cache[22] = _createTextVNode(" Billing ", -1)), _createVNode(LlSupport, {
              class: "ml-2",
              topic: "matterBillingTypes",
              tooltip: "Learn more about billing types"
            })])]), _createElementVNode("div", _hoisted_19, [_createVNode(LlSelect, {
              modelValue: matterFormState.billingType,
              "onUpdate:modelValue": [_cache[3] || (_cache[3] = $event => matterFormState.billingType = $event), _cache[4] || (_cache[4] = $event => matterFormState.matter.copy = false)],
              items: _unref(billingTypes),
              "item-title": "label",
              "item-value": "id",
              "return-object": false,
              label: "",
              placeholder: "Select Billing Type",
              "data-cy": "billing-type-select"
            }, null, 8, ["modelValue", "items"])])]), matterFormState.billingType === 'contingency' ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_cache[23] || (_cache[23] = _createElementVNode("div", {
              class: "w-2/12"
            }, [_createElementVNode("label", {
              class: "pt-2"
            }, "Fee %")], -1)), _createElementVNode("div", _hoisted_21, [_createVNode(LlTextField, {
              modelValue: matterFormState.contingencyFeePercentage,
              "onUpdate:modelValue": [_cache[5] || (_cache[5] = $event => matterFormState.contingencyFeePercentage = $event), _cache[6] || (_cache[6] = $event => matterFormState.matter.copy = false)],
              modelModifiers: {
                number: true
              },
              type: "number",
              label: "",
              placeholder: "Enter a number or leave blank",
              clearable: "",
              min: 0,
              max: 100,
              step: "any",
              suffix: "%",
              rules: contingencyFeeRules,
              "hide-details": "auto",
              "data-cy": "contingency-fee-percentage-input"
            }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), matterFormState.rateGroups.length && matterFormState.billingType !== 'contingency' && matterFormState.billingType !== 'internal' ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_cache[24] || (_cache[24] = _createElementVNode("div", {
              class: "w-2/12"
            }, [_createElementVNode("label", {
              class: "pt-2"
            }, "Rate Group")], -1)), _createElementVNode("div", _hoisted_23, [_createVNode(LlSelect, {
              modelValue: matterFormState.matter.rateGroup.rateGroupId,
              "onUpdate:modelValue": [_cache[7] || (_cache[7] = $event => matterFormState.matter.rateGroup.rateGroupId = $event), rateGroupChanged],
              items: matterFormState.rateGroups,
              "item-title": "name",
              "item-value": "id",
              "return-object": false,
              label: "",
              placeholder: "Select a Rate Group",
              clearable: "",
              "data-cy": "rate-group-select"
            }, null, 8, ["modelValue", "items"])])])) : _createCommentVNode("", true), !uiState.copyLoading ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_cache[26] || (_cache[26] = _createElementVNode("div", {
              class: "w-2/12"
            }, [_createElementVNode("label", {
              class: "pt-2"
            }, [_createTextVNode("Responsible "), _createElementVNode("span", {
              class: "font-weight-bold mr-1"
            }, "*")])], -1)), _createElementVNode("div", _hoisted_25, [_createVNode(LlSelect, {
              modelValue: matterFormState.matter.primary,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => matterFormState.matter.primary = $event),
              items: matterFormState.users,
              "item-title": "name",
              "item-value": "id",
              "return-object": true,
              label: "",
              rules: [v => !!v || 'User is required'],
              "data-cy": "primary-user-select"
            }, null, 8, ["modelValue", "items", "rules"])]), _createElementVNode("div", _hoisted_26, [_createVNode(LlTooltip, {
              icon: "help"
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode("Pick who should be the responsible for this matter", -1)]))]),
              _: 1
            })])])) : _createCommentVNode("", true), !uiState.copyLoading ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("label", _hoisted_29, [_cache[27] || (_cache[27] = _createTextVNode("Originating ", -1)), requireOriginating.value ? (_openBlock(), _createElementBlock("span", _hoisted_30, "*")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_31, [_createVNode(LlSelect, {
              id: "usersOriginating",
              modelValue: matterFormState.matter.originating,
              "onUpdate:modelValue": [_cache[9] || (_cache[9] = $event => matterFormState.matter.originating = $event), _cache[10] || (_cache[10] = $event => matterFormState.matter.copy = false)],
              items: matterFormState.users,
              "item-title": "name",
              "item-value": "id",
              "return-object": true,
              label: "",
              clearable: "",
              placeholder: "Select an Originating User",
              rules: originatingRules.value,
              "data-cy": "originating-user-select"
            }, null, 8, ["modelValue", "items", "rules"])])])) : _createCommentVNode("", true), _unref(me).company?.usesMatterTags ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_cache[28] || (_cache[28] = _createElementVNode("div", {
              class: "w-2/12"
            }, [_createElementVNode("label", {
              class: "pt-2"
            }, "Practice Area")], -1)), _createElementVNode("div", _hoisted_33, [_createVNode(LlPracticeAreaSelect, {
              modelValue: matterFormState.matter.matterTag,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => matterFormState.matter.matterTag = $event),
              "return-object": true,
              "hide-label": true,
              placeholder: "Select a Practice Area",
              "auto-load": false,
              onChange: _cache[12] || (_cache[12] = $event => matterFormState.matter.copy = false),
              "data-cy": "practice-area-select"
            }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), _unref(netDocsLoading) ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createVNode(_component_v_progress_circular, {
              color: "success",
              indeterminate: ""
            })])) : (_openBlock(), _createElementBlock("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("span", null, " You can adjust the information for the " + _toDisplayString(_unref(me)?.terms?.matter) + " in more detail once it is created. ", 1), _unref(netDocsConnected) && !uiState.loadingReference && !_unref(isDisconnectedUnintentionally) && matterFormState.reference ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_unref(me)?.terms?.Matter) + " will be created or matched in NetDocuments upon creation in LeanLaw. ", 1)) : _createCommentVNode("", true)])]), _unref(netDocsConnected) && !uiState.loadingReference && _unref(features)?.netdocs ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_unref(isDisconnectedUnintentionally) && matterFormState.reference ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_unref(me)?.company?.canSetupNetDocs ? (_openBlock(), _createElementBlock("div", _hoisted_41, [...(_cache[29] || (_cache[29] = [_createTextVNode(" NetDocuments is currently disconnected. ", -1), _createElementVNode("a", {
              href: "/settings/integrations",
              class: "underline text-blue-700"
            }, "Reconnect in Settings", -1), _createTextVNode(" to enable automatic matter creation. ", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_42, " NetDocuments is currently disconnected. Please contact your administrator to reconnect NetDocuments. "))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _unref(netDocsConnected) && !uiState.loadingReference ? (_openBlock(), _createElementBlock("div", _hoisted_43, [!matterFormState.reference ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_unref(me)?.terms?.Matter) + " cannot be created in NetDocuments because it's missing " + _toDisplayString(_unref(me)?.terms?.matter) + " ID ", 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]))]),
            _: 1
          })), _createVNode(_component_v_card_actions, {
            class: "d-flex justify-space-between px-6 pb-4"
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(LlSecondaryButton, {
              onClick: cancel,
              "data-cy": "cancel-matter-button"
            }, {
              default: _withCtx(() => [...(_cache[30] || (_cache[30] = [_createTextVNode("Cancel", -1)]))]),
              _: 1
            })]), _createElementVNode("div", _hoisted_45, [matterFormState.billingType === 'fixed' ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createVNode(LlSecondaryButton, {
              id: "save-matter-and-add-fixed-fee-button",
              disabled: saveDisabled.value,
              onClick: _cache[13] || (_cache[13] = $event => save(true)),
              color: "primary",
              variant: "flat",
              loading: uiState.loading
            }, {
              default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode(" Create And Add Fixed Fee ", -1)]))]),
              _: 1
            }, 8, ["disabled", "loading"])])) : _createCommentVNode("", true), _createElementVNode("div", null, [_createVNode(LlSecondaryButton, {
              id: "save-matter-button",
              disabled: saveDisabled.value,
              onClick: _cache[14] || (_cache[14] = $event => save()),
              color: "primary",
              variant: "flat",
              loading: uiState.loading,
              "data-cy": "save-matter-button"
            }, {
              default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createTextVNode(" Create ", -1)]))]),
              _: 1
            }, 8, ["disabled", "loading"])])])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(LlConfirmationDialog, {
        ref_key: "matterExistsDialog",
        ref: matterExistsDialog,
        title: "Matter Already Exists",
        message: `A matter with the name '${matterFormState.matter.name}' already exists for this client. Please consider using a different name or accessing the existing matter.`,
        "confirm-text": "Use Existing",
        "toggle-text": "Create New",
        "data-cy": "matter-exists-dialog"
      }, null, 8, ["message"]), _createVNode(LlConfirmationDialog, {
        ref_key: "matterIdExistsDialog",
        ref: matterIdExistsDialog,
        title: "Matter Id Already Exists",
        message: `A matter with the reference '${matterFormState.reference}' already exists for this client. Please consider using a different reference or accessing the existing matter.`,
        "confirm-text": "Use Existing",
        "toggle-text": "Create New",
        "data-cy": "matter-id-exists-dialog"
      }, null, 8, ["message"])], 544);
    };
  }
};